import apiRoutes from "@/src/apiRoutes"
import { Button } from "@/src/components/Button/Button"
import InputComponent from "@/src/components/Input/Input"
import { Modal } from "@/src/components/Modal/Modal"
import { textVariants } from "@/src/components/Text/Text"
import { Card, CardContent, CardHeader, CardTitle } from "@/src/components/shad/card"
import { CheckEnablers } from "@/src/hooks/check-enablers"
import useUrlState from "@/src/hooks/use-url-state"
import api from "@/src/utils"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import { toast } from "sonner"

const AppEnabled = () => {
    const [modal, setModal] = useUrlState("modal");
    const [code, setCode] = useState('')
    const [action, setACtion] = useState('')
    const { data, refetch } = CheckEnablers('tfa')

    const queryClient = useQueryClient()

    const enable = async () => {
        const res = await api.post(apiRoutes.tfa, {
            type: "enabler",
            action,
            code
        })
        return res.data
    }

    const { mutate, isLoading } = useMutation({
        mutationKey: ['enable_tfa'],
        mutationFn: enable,
        onSuccess: (data) => {
            if (data?.success) {
                toast.success(data?.info)
                refetch()
                setModal(undefined)
            } else {
                toast.warning(data?.info)
            }
        }
    })

    const activate = async () => {
        const res = await api.post(apiRoutes.tfa, {
            type: "activate",
            code
        })
        return res.data
    }

    const { mutate: deactivate, isLoading: deacLoad } = useMutation({
        mutationKey: ['activate_tfa'],
        mutationFn: activate,
        onSuccess: (data) => {
            if (data?.success) {
                toast.success(data?.info)
                setModal(undefined)
                queryClient.invalidateQueries({ queryKey: ['check_tfa_enabled'] })
            } else {
                toast.warning(data?.info)
            }
        }
    })

    return (
        <>
            <Card>
                <CardHeader>
                    <CardTitle>Configure Two Factor Authentication</CardTitle>
                </CardHeader>
                <CardContent className="grid gap-5">
                    <div className="flex justify-between space-x-2 items-center ">
                        <div className="flex flex-col">
                            <span className={textVariants()}>Enable 2FA for withdrawals</span>
                            <span className={textVariants({ size: "sm", variant: "desc" })}>
                                Secure your withdrawals with an extra step of authentication
                            </span>
                        </div>
                        <div>
                            <Button
                                onClick={() => [setModal('open'), setACtion('withdraw')]}
                                variant={data?.info?.withdrawal ? "warning" : "outline"}
                            > {data?.info?.withdrawal ? "Disable" : "Enable"}</Button>
                        </div>
                    </div>
                    <div className="flex justify-between space-x-2 items-center ">
                        <div className="flex flex-col">
                            <span className={textVariants()}>Enable 2FA for login</span>
                            <span className={textVariants({ size: "sm", variant: "desc" })}>
                                Secure every login with an extra step of authentication

                            </span>
                        </div>
                        <div>
                            <Button
                                onClick={() => [setModal('open'), setACtion('login')]}
                                variant={data?.info?.login ? "warning" : "outline"}
                            >{data?.info?.login ? "Disable" : "Enable"}</Button>
                        </div>
                    </div>
                </CardContent>
                <CardHeader className=" bg-back p-2 flex flex-row justify-between items-center border-t rounded-b-lg">
                    <span className={textVariants({ variant: "desc", font: "medium" })}>Disable Two Factor Authentication</span>

                    <Button
                        onClick={() => setModal('deactivate')}

                        variant="warning"
                    >Disable 2FA</Button>
                </CardHeader>
            </Card>
            <Modal
                open={modal === "open"}
                setOpen={(val) => setModal(val ? undefined : "open")}
                title="Enable 2FA"
                // description="From the authenticator app you connected, you will find "
                footer={<div><Button loading={isLoading} disabled={code.length < 6} variant={'outline'} onClick={() => mutate()} >Submit</Button></div>}
                size={'sm'}
            >
                <div>
                    <InputComponent onChange={(e) => setCode(e.target.value)} label="Enter the 2FA code from your authenticator app" />
                </div>
            </Modal>
            <Modal
                open={modal === "deactivate"}
                setOpen={(val) => setModal(val ? undefined : "deactivate")}
                title="Disable 2FA"
                // description="From the authenticator app you connected, you will find "
                footer={<div><Button loading={deacLoad} disabled={code.length < 6} variant={'outline'} onClick={() => deactivate()} >Submit</Button></div>}
                size={'sm'}
            >
                <div>
                    <InputComponent onChange={(e) => setCode(e.target.value)} label="Enter the 2FA code from your authenticator app" />
                </div>
            </Modal>
        </>
    )
}

export default AppEnabled